module.exports = __webpack_public_path__ + "assets/img/section-5-landing-page-mobile-app.75de09d0.png";